import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Configuration WhatsApp - Lien standardisé
  const WHATSAPP_LINK = 'https://wa.me/33640486009?text=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20%F0%9F%92%85';
  const PHONE_NUMBER = '+33640486009';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Bloquer le scroll du body quand le menu est ouvert
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const openWhatsApp = () => {
    window.open(WHATSAPP_LINK, '_blank');
  };

  const menuItems = [
    { id: 'hero', label: 'Accueil' },
    { id: 'services', label: 'Services & Tarifs' },
    { id: 'gallery', label: 'Galerie' },
    { id: 'reviews', label: 'Avis' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white/80 backdrop-blur-sm'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo - plus grand et lisible */}
            <button 
              onClick={() => scrollToSection('hero')}
              className="flex items-center hover:opacity-80 transition-opacity"
            >
              <span className="text-2xl md:text-3xl font-bold brand-font" style={{ color: '#D1477A' }}>
                Nailed by Chloé
              </span>
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-6">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-700 transition-colors font-medium text-sm"
                  style={{ ':hover': { color: '#D1477A' } }}
                  onMouseEnter={(e) => e.target.style.color = '#D1477A'}
                  onMouseLeave={(e) => e.target.style.color = ''}
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={openWhatsApp}
                className="text-white gap-2"
                style={{ backgroundColor: '#D1477A' }}
              >
                <MessageCircle size={18} />
                Réserver
              </Button>
            </nav>

            {/* Mobile: WhatsApp + Menu */}
            <div className="flex items-center gap-2 md:hidden">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white shadow-md"
              >
                <MessageCircle size={20} />
              </a>
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-rose-600 transition-colors"
                aria-label="Menu"
              >
                {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Menu Mobile Plein Écran */}
      <div className={`fixed inset-0 z-40 bg-white transition-transform duration-300 ease-in-out md:hidden ${
        isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="flex flex-col h-full pt-20 px-6">
          <nav className="flex-1 flex flex-col justify-center gap-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-left py-4 text-2xl font-semibold text-gray-800 hover:text-rose-600 transition-colors border-b border-gray-100"
              >
                {item.label}
              </button>
            ))}
          </nav>
          
          {/* Actions en bas du menu */}
          <div className="pb-8 space-y-3">
            <a
              href={`tel:${PHONE_NUMBER}`}
              className="flex items-center justify-center gap-3 w-full py-4 bg-gray-100 rounded-2xl text-gray-800 font-semibold text-lg"
            >
              <Phone size={22} />
              Appeler
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center justify-center gap-3 w-full py-4 bg-green-500 rounded-2xl text-white font-semibold text-lg shadow-lg"
            >
              <MessageCircle size={22} />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
